import { LoginButton, TelegramAuthData } from "@telegram-auth/react";
import { useAuthStore } from "../store/authStore";
import { useAuthByTelegramButton } from "../hooks/useAuthByTelegramButton";
import { env } from "@config/env";
import { logger } from "@/shared/utils/logger";
import WebApp from "@twa-dev/sdk";

export const TelegramAuthButton = () => {
  const isMiniApp = !!WebApp.initData
  const accessToken = useAuthStore((state) => state.accessToken);
  const authMutation = useAuthByTelegramButton();

  if (isMiniApp || accessToken) {
    return null; // Do not show the button inside Mini App
  }

  return (
    <LoginButton
      botUsername={env.botUsername}
      onAuthCallback={(data: TelegramAuthData) => {
        logger.debug("Telegram Login Data:", data);
        logger.info("Telegram authorization confirmed, sending auth data.");
        authMutation.mutate(data);
      }}
      buttonSize="large"
      cornerRadius={5}
      showAvatar={true}
      lang="en"
    />
  );
};
